export const SEARCH_MODAL = {
  INPUT_FOCUS_DELAY: 100,
  MIN_SEARCH_LENGTH: 0,
  LISTBOX_MAX_HEIGHT: 500,
  ITEM_HEIGHT: 64,
  MAX_RESULTS: 30,
} as const;

export const ENTITY_TYPES = [
  { type: "pipeline", label: "Pipeline" },
  { type: "compute", label: "Compute" },
  { type: "task", label: "Task" },
  { type: "dataset", label: "Dataset" },
] as const;
